import React from 'react';

type Props = {
  onOutsideClick: Function;
  className?: string;
};

export class OutsideFocusHandler extends React.Component<Props> {
  wrapperRef = React.createRef<HTMLDivElement>();

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
    document.addEventListener('touchstart', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
    document.removeEventListener('touchstart', this.handleClickOutside);
  }

  handleClickOutside = (event: Event) => {
    const { onOutsideClick } = this.props;
    if (
      this.wrapperRef.current &&
      event.target instanceof Element &&
      !this.wrapperRef.current.contains(event.target)
    ) {
      onOutsideClick();
    }
  };

  render() {
    const { children, className } = this.props;
    return (
      <div className={className} ref={this.wrapperRef}>
        {children}
      </div>
    );
  }
}
